/* eslint-disable max-len */
import jDashBK from '@/views/dashboard/jDashBK';

import jAbsenList from '@/views/bimbingan-konseling/absen/jAbsenList';
import jAbsenCreate from '@/views/bimbingan-konseling/absen/jAbsenCreate';
import jAbsenUpdate from '@/views/bimbingan-konseling/absen/jAbsenUpdate';

import jKonselingList from '@/views/bimbingan-konseling/konseling/jKonselingList';
import jKonselingCreate from '@/views/bimbingan-konseling/konseling/jKonselingCreate';
import jKonselingUpdate from '@/views/bimbingan-konseling/konseling/jKonselingUpdate';

import jLulusanList from '@/views/bimbingan-konseling/lulusan/jLulusanList';
import jLulusanCreate from '@/views/bimbingan-konseling/lulusan/jLulusanCreate';
import jLulusanUpdate from '@/views/bimbingan-konseling/lulusan/jLulusanUpdate';
import jLulusanReport from '@/views/bimbingan-konseling/lulusan/jLulusanReport';

import jBantuanList from '@/views/bimbingan-konseling/calon-penerima-bantuan/jBantuanList';
import jBantuanCreate from '@/views/bimbingan-konseling/calon-penerima-bantuan/jBantuanCreate';
import jBantuanUpdate from '@/views/bimbingan-konseling/calon-penerima-bantuan/jBantuanUpdate';

import auth from '@/middleware/auth';
import log from '@/middleware/log';

export default [
  {
    path: '/dashboard/bk',
    name: 'jDashBK',
    component: jDashBK,
    meta: {
      title: 'Dashboard Bimbingan Konseling',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Administrasi Absensi --------------------------------------
  {
    path: '/admin-absen',
    name: 'jAbsenList',
    component: jAbsenList,
    meta: {
      title: 'Administrasi Absensi',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-absen/create',
    name: 'jAbsenCreate',
    component: jAbsenCreate,
    meta: {
      title: 'Administrasi Absensi',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/admin-absen/detail/:id',
    name: 'jAbsenUpdate',
    component: jAbsenUpdate,
    meta: {
      title: 'Administrasi Absensi',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Administrasi Absensi --------------------------------------
  {
    path: '/konseling',
    name: 'jKonselingList',
    component: jKonselingList,
    meta: {
      title: 'Konseling',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/konseling/create',
    name: 'jKonselingCreate',
    component: jKonselingCreate,
    meta: {
      title: 'Konseling',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/konseling/detail/:id',
    name: 'jKonselingUpdate',
    component: jKonselingUpdate,
    meta: {
      title: 'Konseling',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Penelurusan Lulusan --------------------------------------
  {
    path: '/penelurusan-lulusan',
    name: 'jLulusanList',
    component: jLulusanList,
    meta: {
      title: 'Penelurusan Lulusan',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/penelurusan-lulusan/create',
    name: 'jLulusanCreate',
    component: jLulusanCreate,
    meta: {
      title: 'Penelurusan Lulusan',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/penelurusan-lulusan/detail/:id',
    name: 'jLulusanUpdate',
    component: jLulusanUpdate,
    meta: {
      title: 'Penelurusan Lulusan',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/penelurusan-lulusan/report',
    name: 'jLulusanReport',
    component: jLulusanReport,
    meta: {
      title: 'Penelurusan Lulusan',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  // Penelurusan Calon Penerima Bantuan --------------------------------------
  {
    path: '/penelurusan-calon-penerima-bantuan',
    name: 'jBantuanList',
    component: jBantuanList,
    meta: {
      title: 'Penelurusan Calon Penerima Bantuan',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/penelurusan-calon-penerima-bantuan/create',
    name: 'jBantuanCreate',
    component: jBantuanCreate,
    meta: {
      title: 'Penelurusan Calon Penerima Bantuan',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/penelurusan-calon-penerima-bantuan/detail/:id',
    name: 'jBantuanUpdate',
    component: jBantuanUpdate,
    meta: {
      title: 'Penelurusan Calon Penerima Bantuan',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterBK.js